import { fetchCxGptModels } from "util/copilotChatApi";

/**
 * Advisor access: VoC orgs get Advisor Basic; Advisor Pro (industry_expert) adds live analysis.
 * Uses GET /cx_gpt/models — same gate as chat; response includes advisor_plan fields.
 */
export async function checkCxGptPlanAccess() {
  const result = await fetchCxGptModels();
  if (!result || result.cancel) {
    return {
      hasAccess: false,
      reason: "network",
      message: null,
      advisorPlan: null,
      advisorPlanName: null,
      isPro: false,
    };
  }
  if (result.error) {
    const message =
      typeof result.error === "string"
        ? result.error.trim()
        : String(result.error).trim();
    return {
      hasAccess: false,
      reason: "plan",
      message: message || null,
      advisorPlan: null,
      advisorPlanName: null,
      isPro: false,
    };
  }
  if (Array.isArray(result.models)) {
    const advisorPlan =
      typeof result.advisor_plan === "string" ? result.advisor_plan : "basic";
    const advisorPlanName =
      typeof result.advisor_plan_name === "string"
        ? result.advisor_plan_name
        : advisorPlan === "pro"
          ? "Advisor Pro"
          : "Advisor Basic";
    return {
      hasAccess: true,
      reason: null,
      message: null,
      advisorPlan,
      advisorPlanName,
      advisorMode:
        typeof result.advisor_mode === "string" ? result.advisor_mode : null,
      isPro: result.advisor_is_pro === true || advisorPlan === "pro",
      trial:
        result.advisor_trial && typeof result.advisor_trial === "object"
          ? result.advisor_trial
          : null,
      quotaRemaining:
        result.advisor_quota_remaining != null
          ? Number(result.advisor_quota_remaining)
          : null,
    };
  }
  return {
    hasAccess: false,
    reason: "unknown",
    message: null,
    advisorPlan: null,
    advisorPlanName: null,
    isPro: false,
  };
}
